module.exports = __webpack_public_path__ + "static/media/imagem-steps.92ad8afb.png";